
import React from "react";
import { Separator } from "@/components/ui/separator";

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-50 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-10">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-lg font-semibold text-gray-900">HealthPortal</h3>
              <p className="mt-2 text-sm text-gray-600">
                Connecting healthcare providers, patients, and insurance companies
                for better healthcare management.
              </p>
            </div>
            <div>
              <h3 className="text-sm font-semibold text-gray-900">For Providers</h3>
              <ul className="mt-4 space-y-2">
                <li>
                  <a href="/doctor" className="text-sm text-gray-600 hover:text-blue-600">
                    Doctor Portal
                  </a>
                </li>
                <li>
                  <a href="/hospital" className="text-sm text-gray-600 hover:text-blue-600">
                    Hospital Dashboard
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="text-sm font-semibold text-gray-900">For Patients</h3>
              <ul className="mt-4 space-y-2">
                <li>
                  <a href="/patient" className="text-sm text-gray-600 hover:text-blue-600">
                    Patient Portal
                  </a>
                </li>
                <li>
                  <a href="/insurance" className="text-sm text-gray-600 hover:text-blue-600">
                    Insurance Coverage
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="text-sm font-semibold text-gray-900">Resources</h3>
              <ul className="mt-4 space-y-2">
                <li>
                  <a href="/about" className="text-sm text-gray-600 hover:text-blue-600">
                    About Us
                  </a>
                </li>
                <li>
                  <a href="/contact" className="text-sm text-gray-600 hover:text-blue-600">
                    Contact Us
                  </a>
                </li>
                <li>
                  <a href="/privacy" className="text-sm text-gray-600 hover:text-blue-600">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="/terms" className="text-sm text-gray-600 hover:text-blue-600">
                    Terms of Service
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <Separator className="my-8" />
          <p className="text-sm text-gray-600 text-center">
            &copy; {new Date().getFullYear()} HealthPortal. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
